import styled from 'styled-components';

import {
  SYS_BREAKPOINT_XS,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_SPACE_RELATIVE_BP2_XL_6_XL,
  SYS_SPACE_RELATIVE_BP_XS_6_XL,
  SYS_SPACE_RELATIVE_BP_SM_6_XL,
  SYS_SPACE_RELATIVE_BP_MD_6_XL,
  SYS_SPACE_RELATIVE_BP_LG_6_XL,
  SYS_SPACE_RELATIVE_BP_XL_6_XL,
} from '@oneaudi/unified-web-common';

export const MainContainer = styled.div`
  width: 100%;
  max-width: 1920px;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    flex-direction: column;
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_XS_6_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_SM_6_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_MD_6_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    flex-direction: row;
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_LG_6_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_XL_6_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    margin-bottom: ${SYS_SPACE_RELATIVE_BP2_XL_6_XL};
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  box-sizing: border-box;
  .nba {
    flex-basis: 100%;
  }
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    &.pdp-stage {
      min-height: 240px;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    &.pdp-stage {
      min-height: 290px;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    &.pdp-stage {
      min-height: 567px;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    &.pdp-stage {
      min-height: 472px;
      width: 65%;
    }
    &.pdp-carinfo {
      width: 35%;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    &.pdp-stage {
      min-height: 720px;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    &.pdp-stage {
      width: 60%;
      min-height: 804px;
    }
    &.pdp-carinfo {
      width: 40%;
    }
  }
`;
